import api from './utilBackoffice';

const controller = 'LogErroArquivo4111';
const url = process.env.VUE_APP_ROOT_API + controller;

export default Object.assign({}, api.GetCrud(controller, null), {
  Get: dto => api.Axios.GetParams(url, dto)
});
